<template>
    <div class="overlay">
       <div class="content flex flex-col items-center justify-center px-4 md:px-0">
         <p class="text-2xl md:text-4xl text-brand-blue font-bold">Играем дома!</p>
             <p class="text-width text-xs md:text-lg mt-4 md:mt-10">Мы с вами! Переносим атмосферу любимой барной викторины в вашу квартиру с Мозгобойней Live. </p>
             <p class="text-width text-xs md:text-lg mt-4 md:mt-8">Устраиваем домашние вечеринки под классические и тематически игры MozgoParty.</p>
             <div class="mt-10 flex flex-col md:flex-row w-full md:w-auto">
                 <div class="bg-brand-light hover-up rounded-full   text-center  button-width py-3 md:py-4 font-bold   cursor-pointer text-sm md:text-lg">
                   <a class="text-white no-underline" :href="live">Сыграть Live</a>
                 </div>
                 <div class="bg-white border border-additional-text hover-up rounded-full   text-center  button-width py-3 md:py-4 font-bold  ml-0 md:ml-5 mt-5 md:mt-0 cursor-pointer text-sm md:text-lg">
                   <a class="text-main-text no-underline" :href="party">Сыграть в MozgoParty</a>
                 </div>
             </div>
           <button class="absolute pin-t pin-r outline-none m-4 pt-1 md:pt-0 md:m-8 z-40 mobile-cross rounded-full" @click="close">
            <img class="h-4 md:h-5" src="@/assets/SVG/cross-partners.svg" />
          </button>
       </div>
    </div>
</template>
<script>
export default {
  name: 'quarantine',
  data() {
    return {
      party: process.env.VUE_APP_MOZGO_PARTY,
      live: process.env.VUE_APP_MOZGO_LIVE,

    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style scoped>
.overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 16777270
}
.content {
    width: 80%;
    height: 83%;
    background: url('../assets/qurantine-modal-bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-color: white;
    z-index: 16777271;
    position: relative;
    border-radius:10px;
}
.text-width {
    max-width: 500px;
    text-align: center;
    color: #333333;
    line-height: 22px;
}
.button-width {
    width: 270px;
}
@media (max-width: 840px) {
    .content {
        background: url('../assets/quarantine-mobile-bg.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        background-color: white;
        border-radius: 0;
        width: 100vw;
        height: 100vh;
    }
    .mobile-cross {
        background: rgba(255, 255, 255, 0.8);
        width: 32px;
        height: 32px;
    }
    .text-width {
        max-width: 250px;
        line-height: 15px;
    }
    .button-width {
        width: 100%;
    }
}
</style>
